<template>
  <div class="bg-white relative menucontrol-scroll fixed-top">
    <Banner />
    <VersionTable />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import VersionTable from "./components/VersionTable.vue";
export default {
  components: {
    Banner,
    VersionTable,
  },
};
</script>
